<template>
  <div class="dialog-body">

    <!-- 对话框 -->
    <el-dialog :visible.sync="show" width="50%" top="10vh" :close-on-click-modal="false" :before-close="closeDialog">


      <div class="push-box-window">


        <div class="push-box">

          <div class="push-box-in" v-for="(item, index) in webSocket_data_arrway" @click="select(index)">


            <div class="push-box-in-top">


              <div class="push-box-in-top-left click-success" v-if="item.code == 200 && item.data !=null">

                <i class="el-icon-caret-right"></i>

              </div>

              <div class="push-box-in-top-left click-err" v-if="item.code != 200 && item.data !=null">

                <i class="el-icon-caret-right"></i>

              </div>

              <div class="push-box-in-top-left noclick-err" v-if="item.code != 200 && item.data ==null">

                <i class="el-icon-warning-outline"></i>

              </div>

              <div class="push-box-in-top-left noclick-success" v-if="item.code  == 200 && item.data ==null">

                <i class="el-icon-check"></i>

              </div>



              <div class="push-box-in-top-right">

                <div class="push-box-in-top-right-title">

                  {{item.msg}}

                </div>

                <div class="push-box-in-top-right-tag">

                  <el-tag v-for="(item2,index) in item.tag" :type="item2.tag" class="push-box-in-top-right-tag-tag">
                    {{ item2.title }}
                  </el-tag>



                </div>

              </div>


            </div>


            <div class="push-box-in-bottom">


              <div class="push-box-in-bottom-box">

                <div class="push-box-in-bottom-box-left">
                  <div style="font-weight: bold;">标识</div>

                </div>
                <div class="push-box-in-bottom-box-right">
                  <div style="font-weight: bold;">内容</div>

                </div>

              </div>


              <div class="push-box-in-bottom-box" v-for="(val, index) in item.data">

                <div class="push-box-in-bottom-box-left">
                  <div>{{index}}</div>

                </div>
                <div class="push-box-in-bottom-box-right">
                  <div>{{val}}</div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </el-dialog>
  </div>
</template>






<script>
  var _this;
  import {
    config
  } from '../../utils/config'; //配置
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },

    watch: {

      isShow(newData, oldData) {
        _this.show = true;
      }


    },
    data() {
      return {

        show: false,

        // webSocket
        webSocket: null,
        url: '112.126.87.113:9502',

        //发送初始化链接参数
        sendData: {
          ws_mode: '',
          port: 'admin',
          platform: 'pc',
          token: '',
          hash_key: ''
        },

        // 所有数据的数组
        webSocket_data_arrway: [],

        // 记录重连次数
        num: 0,

        //记录背景色
        background_color: ''

      };
    },
    created() {
      _this = this;
      // token
      var token = localStorage.getItem(config.localStorage_token_name);

      // 哈希值
      var hash_key = this.$hash_key();
      _this.sendData.ws_mode = 'link';
      _this.sendData.token = token;
      _this.sendData.hash_key = hash_key;

      // 页面打开就建立连接
      // this.initSocket();
    },
    methods: {
      select(index) {

        // 获取dom节点(数组)
        var boxInDom = document.getElementsByClassName('push-box-in-bottom');

        var boxTopLeftDom = document.getElementsByClassName('push-box-in-top-left');


        // 判断元素class名称决定点击是否可以展开
        if (boxTopLeftDom[index].getAttribute('class') == 'push-box-in-top-left click-success' || boxTopLeftDom[index]
          .getAttribute('class') == 'push-box-in-top-left click-err' || boxTopLeftDom[index].getAttribute('class') ==
          'push-box-in-top-left grey') {


          //判断是否存在active类名
          if (boxInDom[index].classList.contains('active') == true) {

            boxInDom[index].classList.remove('active');

            boxTopLeftDom[index].classList.remove('grey');

            boxTopLeftDom[index].className = _this.background_color;

            boxTopLeftDom[index].childNodes[0].className = 'el-icon-caret-right'


          } else {

            boxInDom[index].classList.add('active');

            if (boxTopLeftDom[index].getAttribute('class') == 'push-box-in-top-left click-err') {

              _this.background_color = 'push-box-in-top-left click-err';

              boxTopLeftDom[index].classList.remove('click-err');

              boxTopLeftDom[index].classList.add('grey');


            } else if (boxTopLeftDom[index].getAttribute('class') == 'push-box-in-top-left click-success') {

              _this.background_color = 'push-box-in-top-left click-success';

              boxTopLeftDom[index].classList.remove('click-success');

              boxTopLeftDom[index].classList.add('grey');

            }

            boxTopLeftDom[index].childNodes[0].className = 'el-icon-caret-bottom';

          }
        } else {

          return false;

        }

      },
      // 建立连接
      initSocket() {

        // 有参数的情况下：
        let url = `wss://${this.url}`
        // 没有参数的情况:接口
        // let url1 = 'ws://localhost:9998'
        this.webSocket = new WebSocket(url);
        this.webSocket.onopen = this.webSocketOnOpen;
        this.webSocket.onclose = this.webSocketOnClose;
        this.webSocket.onmessage = this.webSocketOnMessage;
        this.webSocket.onerror = this.webSocketOnError;

      },

      // 建立连接成功后的状态
      webSocketOnOpen() {

        // 发送数据
        _this.webSocket.send(JSON.stringify(_this.sendData));

      },

      // 获取到后台消息的事件，操作数据的代码在onmessage中书写
      webSocketOnMessage(res) {

        //格式化返回数据
        var getData = JSON.parse(res.data);


        // 加入所有数据的数组
        _this.webSocket_data_arrway.push(getData);

        console.log(res.data);


      },

      // 关闭连接
      webSocketOnClose() {



      },

      //连接失败的事件
      webSocketOnError(res) {

        _this.sendData.ws_mode = 'relink';

        //做计时器，重连10次
        var t = setInterval(() => {

          let url = `wss://${this.url}`
          this.webSocket = new WebSocket(url);
          this.webSocket.onopen = this.webSocketOnOpen;
          this.webSocket.onclose = this.webSocketOnClose;
          this.webSocket.onmessage = this.webSocketOnMessage;

          if (_this.num < 10) {
            _this.num++;
          } else {
            // 清除计时器
            clearInterval(t);

            // 链接错误提示
            this.$notify({
              message: '公屏数据连接失败',
              duration: 0,
              type: 'warning'
            });

          }

        }, 3000);

      },


      // 关闭方法
      closeDialog() {

        _this.show = false;

      }
    }
  };
</script>

<style scoped>
  .push-box-window {

    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    height: 60vh;
    overflow: auto;

  }


  .push-box {

    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 94%;
    margin-left: 3%;

  }


  .push-box-in {

    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background: #FFF;
    border-bottom: 1px dotted #EEE;
    margin-bottom: 5px;
    width: 100%;
    min-height: 60px;
    padding: 10px 0px 15px 0px;

  }

  .push-box-in-top {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 60px;

  }

  .push-box-in-bottom {
    display: none;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    min-height: 10px;
    padding-bottom: 20px;
    margin-top: 10px;

  }

  .push-box-in-bottom.active {
    display: flex;
  }

  .push-box-in-bottom-box {

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 5px;
    width: 100%;
    min-height: 30px;
    line-height: 30px;

    border-bottom: 1px dotted #DDD;

  }

  .push-box-in-bottom-box-left {

    width: 17%;
    height: 30px;
    text-align: right;
    padding-right: 3%;
    overflow: hidden;

  }

  .push-box-in-bottom-box-right {
    width: 78%;
    min-height: 30px;
    padding-left: 2%;

  }

  .push-box-in-top-left {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: #f90;
    color: #FFF;
    border-radius: 100%;
    width: 25px;
    height: 25px;
    margin: 0px 10px 0px 15px;
    font-weight: bold;
    font-size: 18px;

  }

  .push-box-in-top-left.noclick-err {
    background: #E6A23C;
  }

  .push-box-in-top-left.noclick-success {
    background: #5CBB7A;
  }

  .push-box-in-top-left.click-success {
    background: #409EFF;
  }

  .push-box-in-top-left.click-err {
    background: #f56C6C;
  }

  .push-box-in-top-left.grey {
    background: #909399;
  }

  .push-box-in-top-right {

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    height: 50px;
    margin-top: 10px;

  }



  .push-box-in-top-right-title {

    font-weight: bold;
    font-size: 16px;
    width: 100%;
    height: 30px;

  }

  .push-box-in-top-right-tag {

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 20px;

  }

  .push-box-in-top-right-tag-tag {

    margin-right: 5px;

  }


  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .el-collapse {
    border-bottom: 0;
  }

  .tag_group {
    display: block;
    width: 100%;
  }

  .collapse-content {
    margin: 10px 0;
    padding-left: 30px;
    box-sizing: border-box;
  }
</style>